import connect from './connect';
import ExchangeTable from './ExchangeTable';

// @ts-expect-error $TSFixMeError: Argument of type 'typeof ExchangeTable' is not assignable to parameter of type 'ComponentType<Matching<{ exchangeRates: ...
export default connect(ExchangeTable);
